import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import { Typography, TextField } from "@material-ui/core/";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import ProgressBar from "./ProgressBar";
import FormControl from "@material-ui/core/FormControl";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import AutocompleteSearch from "./SelectAutocomplete";
import Checkbox from "@material-ui/core/Checkbox";

import "../styles/main.css";

const vw = Math.max(
  document.documentElement.clientWidth,
  window.innerWidth || 0
);
const mobileViewport = vw < 768 ? true : false;

const theme = createMuiTheme({
  direction: "rtl",
});

const StyledTextField = withStyles({
  root: {
    width: "100%",
    height: "48px",
    padding: "0px",

    dir: "rtl",
    opacity: 1,
    color: "#4A4547",
    borderRadius: "4px",
    marginBottom: mobileViewport ? "20px" : "32px",
    "& label": {
      color: "#4A4547",
      fontSize: mobileViewport ? "14px" : "16px",
    },

    "& label.Mui-focused": {
      color: "#32C6A9",
      fontSize: mobileViewport ? "14px" : "16px",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "1px solid #707070",
        opacity: 1,
        padding: "0px",
      },
      "&.Mui-focused fieldset": {
        border: "2px solid #32C6A9",
      },
      padding: "0px",
      height: "48px",
    },
  },
})(TextField);

const StyledButtonNext = withStyles({
  root: {
    display: "flex",
    height: "48px",
    background: "#32C6A9 0% 0% no-repeat padding-box",
    borderRadius: "4px",
    opacity: 1,
    fontSize: mobileViewport ? "14px" : "18px",
    fontWeight: "bold",
    boxShadow: "none",

    "&:hover": {
      backgroundColor: "#32C6A9",
      boxShadow: "0px 3px 6px #32C6A9B3",
    },
    "&:active": {
      backgroundColor: "#4A4547",
      boxShadow: "none",
    },
  },
})(Button);

const StyledText = withStyles({
  root: {
    width: "83%",
    textAlign: "right",
    margin: mobileViewport ? "17px 0 10px 0" : "24px 0 10px 0",
    fontSize: mobileViewport ? "14px" : "16px",
    letterSpacing: 0,
    color: "#4A4547",
    opacity: 1,
    lineHeight: "1.5rem",
  },
})(Typography);

const StyledFormControlLabel = withStyles({
  root: {
    color: "#4A4547",
  },
})(FormControlLabel);

const StyledCheckboxFormControlLabel = withStyles({
  root: {
    color: "#4A4547",
    marginRight: "-9px",
  },
})(FormControlLabel);

const StyledFormControl = withStyles({
  root: {
    // marginTop: "24px",
    display: "block",
    height: "65px",
    color: "#4A4547",
  },
})(FormControl);

const StyledRadio = withStyles({
  root: {
    "& svg:first-child": {
      transform: "scale(1)",
      transform: "translateZ(0)",
    },
  },
})(Radio);

export class FirstPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  saveToLocalStorage = () => {
    this.props.saveToLocalStorage();
  };

  continue = async (e) => {
    e.preventDefault();
    await this.saveToLocalStorage();
    this.props.nextStep();
  };

  render() {
    const {
      values,
      handleChangeName,
      handleChangePhoneNumber,
      handleSchool,
      handleChangeLanguage,
      handleChangeClassRadio,
      cancel,
    } = this.props;

    return (
      <React.Fragment>
        <Grid container spacing={0}>
          <Grid item xs={2}>
            <div className="white-space-side">
              <img
                className="pageImg"
                src={require("../assets/logotext.svg")}
                title="first page"
                alt="pic"
              />
            </div>
          </Grid>
          <Grid item xs={8}>
            <div style={{ direction: "rtl" }}>
              <ProgressBar currStep={this.props.currStep} />
            </div>
            <form onSubmit={this.continue} className="page-form">
              <div className="main-content">
                <div className="wrapper" dir="rtl">
                  <ThemeProvider theme={theme}>
                    <StyledTextField
                      autoFocus
                      required={true}
                      label="שם מלא*"
                      variant="outlined"
                      value={values.fullName}
                      onChange={(e) => handleChangeName(e)}
                    ></StyledTextField>
                  </ThemeProvider>

                  <ThemeProvider theme={theme}>
                    <StyledTextField
                      type="number"
                      pattern="[0-9]*"
                      error={this.props.invalidPhone ? true : false}
                      required={true}
                      label="הכנס את מספר הטלפון של התלמיד*"
                      variant="outlined"
                      value={values.phoneNumber}
                      onChange={(e) => handleChangePhoneNumber(e)}
                    ></StyledTextField>

                    <p className="error-text">
                      {this.props.invalidPhone ? "מספר לא תקין" : " "}
                    </p>
                  </ThemeProvider>

                  <ThemeProvider theme={theme}>
                    <AutocompleteSearch
                      handleCityValues={this.props.handleCityValues}
                      citySelected={values.citySelection}
                    />
                  </ThemeProvider>

                  <ThemeProvider theme={theme}>
                    <StyledTextField
                      required={true}
                      label="בית ספר*"
                      variant="outlined"
                      error={this.props.invalidSchoolname ? true : false}
                      value={values.schoolInput}
                      onChange={(e) => handleSchool(e)}
                    ></StyledTextField>
                    <p className="error-text">
                      {this.props.invalidSchoolname
                        ? "שם בית ספר קצר מדי"
                        : " "}
                    </p>
                  </ThemeProvider>

                  <StyledText
                    variant="overline"
                    display="block"
                    className="text"
                    gutterBottom
                    dir="rtl"
                  >
                    במידה ויתאפשר האם תרצה להיות בכיתה:
                  </StyledText>

                  <ThemeProvider>
                    <FormControl>
                      <RadioGroup
                        value={values.classRadio}
                        aria-label="classRadio"
                        name="customized-radios"
                        onChange={(e) => handleChangeClassRadio(e)}
                      >
                        <StyledFormControlLabel
                          value="מעורבת (בנים ובנות)"
                          control={<StyledRadio color="default" />}
                          label="מעורבת (בנים ובנות)"
                          labelPlacement="end"
                        />
                        <StyledFormControlLabel
                          value="בנים לחוד"
                          control={<StyledRadio color="default" />}
                          label="בנים לחוד"
                          labelPlacement="end"
                        />
                        <StyledFormControlLabel
                          value="בנות לחוד"
                          control={<StyledRadio color="default" />}
                          label="בנות לחוד"
                          labelPlacement="end"
                        />
                      </RadioGroup>
                    </FormControl>
                  </ThemeProvider>

                  <StyledText
                    variant="overline"
                    display="block"
                    className="text"
                    gutterBottom
                    dir="rtl"
                    style={{
                      margin: mobileViewport
                        ? "15px 0 10px 0"
                        : "24px 0 10px 0",
                    }}
                  >
                    במידת האפשר האם תרצה לבחור בין שיעורים בעברית או ערבית
                  </StyledText>

                  <ThemeProvider>
                    <FormControl>
                      <RadioGroup
                        value={values.language}
                        aria-label="language"
                        name="customized-radios"
                        onChange={(e) => handleChangeLanguage(e)}
                      >
                        <StyledFormControlLabel
                          value="עברית"
                          control={<StyledRadio color="default" />}
                          label="עברית"
                          labelPlacement="end"
                        />
                        <StyledFormControlLabel
                          value="ערבית"
                          control={<StyledRadio color="default" />}
                          label="ערבית"
                          labelPlacement="end"
                        />
                      </RadioGroup>
                    </FormControl>
                  </ThemeProvider>
                </div>
                {/* white space div */}
                <div className="white-space-wrapper-bottom"></div>
              </div>

              <div
                className="button-container"
                dir="ltr"
                style={{
                  justifyContent: "flex-start",
                  width: "calc(100%-174px)",
                }}
              >
                <StyledButtonNext
                  color="secondary"
                  variant="contained"
                  type="submit"
                  disabled={
                    this.props.invalidPhone || this.props.invalidSchoolname
                      ? true
                      : false
                  }
                >
                  <i
                    className="material-icons"
                    style={{
                      fontSize: "32px",
                      marginRight: "5px",
                      marginLeft: "-12px",
                    }}
                  >
                    keyboard_arrow_left
                  </i>
                  המשך
                </StyledButtonNext>
                <div
                  className="button-cancel"
                  variant="contained"
                  onClick={cancel}
                  style={{ marginLeft: "13%" }}
                >
                  לבטל
                </div>
              </div>
              <div className="contact-info-div">
                <p
                  className="contact-text-bottom"
                  variant="caption"
                  display="block"
                >
                  לכל שאלה, בעיה אנחנו כאן
                  <br />
                  טלפון: <a href={"tel:052-8808558"}>052-8808558</a> מייל:{" "}
                  <a href={"mailto:contact@class.me"}>contact@class.me</a>
                </p>
                <p className="terms">
                  <br />
                  <a href={"https://class.me/termsHE.html"}>
                    תנאי שימוש ומדיניות פרטיות
                  </a>
                </p>
              </div>
            </form>
          </Grid>

          <Grid item xs={2}>
            <div className="white-space-side"></div>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

export default FirstPage;
